import React, { useCallback } from "react";
import { connect } from "react-redux";

import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import SchemaField from "@mapmycustomers/shared/types/schema/SchemaField";
import { Popconfirm } from "@mapmycustomers/ui";

import useAnalytics from "@app/util/contexts/useAnalytics";

import { archiveField } from "../../store/actions";

import styles from "./ArchiveActionMenuLabel.module.scss";
import messages from "./messages";

interface Props {
  disabled: boolean;
  field: SchemaField;
  onArchiveField: typeof archiveField.request;
}

const ArchiveActionMenuLabel: React.FC<Props> = ({ disabled, field, onArchiveField }) => {
  const intl = useIntl();
  const analytics = useAnalytics();

  const handleAction = useCallback(() => {
    analytics?.clicked(["Field", "Archive Field"]);
    onArchiveField(field);
  }, [analytics, field, onArchiveField]);

  return (
    <span>
      <Popconfirm
        cancelText={intl.formatMessage(messages.cancel)}
        description={intl.formatMessage(messages.description, {
          b: (text) => <b className={styles.warning}>{text}</b>,
          p: (text) => <p>{text}</p>,
        })}
        disabled={disabled}
        okText={intl.formatMessage(messages.ok)}
        onConfirm={handleAction}
        placement="bottomRight"
        title={intl.formatMessage(messages.title)}
      >
        <Tooltip
          arrowPointAtCenter
          overlayClassName={styles.tooltip}
          placement="left"
          title={
            !field.canArchive
              ? intl.formatMessage(messages.systemRequired)
              : field.usedInWorkflow
              ? intl.formatMessage(messages.usedInWorkflow)
              : undefined
          }
        >
          {intl.formatMessage(messages.archive)}
        </Tooltip>
      </Popconfirm>
    </span>
  );
};

const mapDispatchToProps = {
  onArchiveField: archiveField.request,
};

export default connect(null, mapDispatchToProps)(ArchiveActionMenuLabel);
